module.exports = __webpack_public_path__ + "static/media/filter.4952ff9d.svg";